import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext({});
// Se sei in locale (npm start), React chiamerà il server remoto. 
// Se sei in produzione (npm run build), userà il percorso relativo.
// Sostituisci "https://www.yogacomo.com" con il tuo VERO dominio.
export const API_BASE_URL = process.env.NODE_ENV === 'development'
  ? 'https://www.yogacomo.com/api'
  : '/api';

// Base URL per le immagini caricate (uploads)
export const UPLOADS_BASE_URL = process.env.NODE_ENV === 'development'
  ? 'https://www.yogacomo.com'
  : '';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Controlla se c'è un token salvato in localStorage
    const token = localStorage.getItem('adminToken');
    const storedUser = localStorage.getItem('adminUser');

    if (token && storedUser && storedUser !== 'undefined') {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error("Errore nel parsing dell'utente da localStorage:", e);
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        setUser(null);
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const response = await fetch(`${API_BASE_URL}/login.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Errore di autenticazione');
    }

    // Salva token e utente
    localStorage.setItem('adminToken', data.token);
    localStorage.setItem('adminUser', JSON.stringify(data.user));
    setUser(data.user);

    return data;
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
